import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetActiveSubscription = () => {
  const {
    data: subscription,
    isLoading: subscriptionLoading,
    error: subscriptionError,
    refetch: refetchSubscription,
  } = useAuthenticatedQuery(
    ["activeSubscription"],
    "/api/v1/subscriptions/active",
    {
      // Don't show error toast for 404 (no subscription)
      useErrorBoundary: false,
      // Don't retry on 404 or NOT_FOUND error
      retry: (failureCount, error) => {
        const isNotFound =
          error.response?.status === 404 ||
          error.response?.data?.error_code === "NOT_FOUND";
        return !isNotFound && failureCount < 2;
      },
      // Log errors for debugging
      onError: (error) => {
        console.log("Subscription check error:", {
          status: error.response?.status,
          data: error.response?.data,
          error_code: error.response?.data?.error_code,
        });
      },
    }
  );

  return {
    subscription,
    subscriptionLoading,
    subscriptionError,
    refetchSubscription,
  };
};

export default useGetActiveSubscription;
